<template>
    <b-modal ref="modal" size="lg" centered :title="$t('WARRANTY')" @close="close()" no-close-on-backdrop no-close-on-esc hide-footer>
        <div class="d-block mt-2">
          <div role="group" class="b-form-group form-group" v-if="formValues != null">
            <div v-if="globals.salesStaf != globals.groupId || (formValues.status == null ||  formValues.status != 'active')">
                <div class="form-row mb-lg">
                  <div class="col-sm-2">
                    <label for="input-default">{{$t('ENTERNEWAMOUNT')}}</label>
                  </div>
                  <div class="col-sm-8">
                    <b-form-input type="number" v-model="formValues.amount"></b-form-input>
                  </div>
                  <div class="col-sm-2">
                    <b-btn variant="primary" @click="submitData(formValues)">{{$t('ADDAMOUNT')}}</b-btn>
                  </div>
                </div>
                <br>
                <div class="form-row mb-lg">
                  <div class="col-sm-12 table-responsive">
                    <table class="table table-bordered table-striped table-hover table-sm table-logoped">
                      <thead>
                        <tr>
                          <th>
                            {{$t('CHILDNAME')}}
                          </th>
                          <th>
                            {{$t('AMOUNT')}}
                          </th>
                          <th>
                            {{$t('USER')}}
                          </th>
                          <th>
                            {{$t('DATEOFCHANGE')}}
                          </th>
                          <th>
                            {{$t('RECORDDATETIME')}}
                          </th>
                          <th>
                            {{$t('RECORDSTATUS')}}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr :key="item.dateTime" aria-rowindex="1" class=" table-ellipsis" v-for="item in walletData">
                          <td>{{item.childName}}</td>
                          <td>{{item.amount}}</td>
                          <td>{{item.userName}}</td>
                          <td>{{item.dateTime}}</td>
                          <td>{{item.recordDateTime}}</td>
                          <td>{{ (item.recordStatus) ? $t(item.recordStatus.toUpperCase()) : '' }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <nav>
                      <pagination v-bind:totalCount="walletData.totalCount" v-model="pagination" v-on:reload="getData">
                      </pagination>
                    </nav>
                  </div>
                </div>             
            </div>
          </div>

          <div class="text-right">
              <b-btn variant="secondary-trans mr-4" @click="close()">{{$t('CLOSE')}}</b-btn>
          </div>
        </div>
    </b-modal>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';    
import Api from '@/api/wallet/Wallet';

export default
{
    name: 'WalletForm',
    props: ['value'],
    data()
    {
        const me = this;

        return {
            formValues: {
              amount: 0,
            },
            walletData: {},
            formError: {},
            formData: null,
            pagination:
            {
                query: '',
                currentPage: 1,
                limit: 25,
                searchTimeout: false,
            },
        };
    },
    methods:
    {
        async getData()
        {
          const me = this;
          try 
          {
            const data = await Api.selectRow(me.getParams);
            if (data.error && data.error === true)
            {
              throw (data);
            }
            me.walletData = data.root;
          } 
          catch (error) 
          {
            console.log(error);
            me.$notify.notice(error);
          }
        },
        async submitData(item)
        {
            const me = this;
            try
            {                
                item.childId = me.formData.childId;
                const data = await Api.submitData(item);
                me.$notify.notice(data);

                if (data.error)
                {
                    me.formError = data;
                }
                else
                {
                    me.getData();
                }
            }
            catch (e)
            {
                console.log(e);
                me.$notify.notice(e);
            }
        },
        close()
        {
            const me = this;
            me.formData = null;
            me.formError = {};
            me.formValues = {
              amount: 0,
            };
            me.$emit('close');
        },
    },
    watch:
    {
        async formData(val)
        {
            const me = this;
            if (val != null)
            {
                await me.getData();
                me.$refs.modal.show();
            }
            else
            {
                me.$refs.modal.hide();
            }
        },
        value(val)
        {
            const me = this;
            if (val != null)
            {
                me.formData = { ...val };
            }
            else
            {
                me.formData = null;
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
        getParams()
        {
            const me = this;
            const data = {
                ...me.pagination,
            };
            data.start = (data.currentPage - 1) * data.limit;

            data.childId = me.formData.childId;
            return data;
        },
    },
};
</script>
